import { Box, Typography } from '@mui/material'
import { useState, useEffect } from 'react'
import { useAppTheme } from '@/theme/ThemeContext'
import {
  getAccountDashboard,
  getAccountLogoUrl,
} from '@/services/dashboardService'

export default function LogoBox({
  borderColor = '#323B771A',
  textColor = '#003F61',
}) {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'
  const [accountName, setAccountName] = useState('')
  const [logoUrl, setLogoUrl] = useState<string | null>(null)

  useEffect(() => {
    const accountId = localStorage.getItem('accountId')
    if (accountId) {
      setLogoUrl(getAccountLogoUrl(accountId))
    }

    const fetchAccount = async () => {
      try {
        const data = await getAccountDashboard()
        if (data) {
          setAccountName(data.accountName || '')
          setLogoUrl(getAccountLogoUrl(data.accountId))
        }
      } catch (error) {
        // Keep the logo visible when only the account metadata request fails.
        console.warn('[LogoBox] Failed to load account name:', error)
      }
    }
    void fetchAccount()
  }, [])

  // Theme-aware colors
  const colors = {
    text: isDarkMode ? '#FFFFFF' : textColor,
    border: isDarkMode ? '#374151' : borderColor,
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
      }}
    >
      <Typography
        sx={{
          // Shrinkable, not fixed: a fixed 400px box pushed the header (and the
          // back-to-sites button after it) under the sidebar below ~1100px.
          maxWidth: '400px',
          minWidth: 0,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          color: colors.text,
          textAlign: 'right',
          fontFamily: 'Rubik, sans-serif',
          fontSize: '50px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: '38px',
        }}
      >
        {accountName}
      </Typography>
      {logoUrl && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            borderRadius: '50%',
            objectFit: 'cover',
            border: `2px solid ${colors.border}`,
            backgroundColor: 'white',
            marginLeft: 1,
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          <img
            src={logoUrl}
            alt="Logo"
            style={{
              width: 110,
              height: 110,
              flexShrink: 0,
              objectFit: 'cover',
            }}
            onError={e => {
              e.currentTarget.style.display = 'none'
            }}
          />
        </Box>
      )}
    </Box>
  )
}
